"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Testimonials = exports.Author = exports.Comment = exports.CommentWrapper = exports.Picture = exports.Box = exports.StyledTestimonials = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_intl_1 = require("react-intl");
const get_cms_asset_1 = __importDefault(require("@src/helpers/get-cms-asset"));
const styled_breakpoints_1 = require("styled-breakpoints");
const react_router_dom_1 = require("react-router-dom");
const useSSRFetch_1 = require("@src/hooks/useSSRFetch");
exports.StyledTestimonials = styled_components_1.default.div ``;
exports.Box = styled_components_1.default.div `
	width: 100%;
	display: flex;
	padding: 0;
	position: relative;
	flex-direction: column;

	${(0, styled_breakpoints_1.up)('md')} {
		flex-direction: row;
	}

	& + & {
		padding-top: 4em;
	}
`;
exports.Picture = styled_components_1.default.div `
	width: 200px;
	height: 200px;
	margin: 0 0 2em;
	border-radius: 100%;
	overflow: hidden;
	align-self: center;

	${(0, styled_breakpoints_1.up)('md')} {
		margin: 0 2em;
	}

	& img {
		display: block;
		max-width: 100%;
	}
`;
exports.CommentWrapper = styled_components_1.default.div `
	align-self: center;
	flex: 1;
	padding: 0 2em;
	text-align: center;

	${(0, styled_breakpoints_1.up)('md')} {
		text-align: left;
	}
`;
exports.Comment = styled_components_1.default.div `
	font-size: 1.3em;
	font-weight: 400;
	color: ${props => props.theme.color.gray7};
`;
exports.Author = styled_components_1.default.div `
	margin-top: 1em;
	font-size: 1.3em;
	color: ${props => props.theme.color.gray6};

	strong {
		color: ${props => props.theme.color.brand3};
	}

	a {
		text-decoration: underline;
	}
`;
const Testimonials = () => {
    const intl = (0, react_intl_1.useIntl)();
    const location = (0, react_router_dom_1.useLocation)();
    const { data: testimonials } = (0, useSSRFetch_1.useSSRFetch)(useSSRFetch_1.SSRFetchConfig.testimonials.key, intl.locale, [
        location.pathname,
    ]);
    return ((0, jsx_runtime_1.jsx)(exports.StyledTestimonials, { children: testimonials &&
            testimonials.entries.map(item => {
                return ((0, jsx_runtime_1.jsxs)(exports.Box, { children: [(0, jsx_runtime_1.jsx)(exports.Picture, { children: (0, jsx_runtime_1.jsx)("img", { src: (0, get_cms_asset_1.default)(item.image), alt: "" }) }), (0, jsx_runtime_1.jsxs)(exports.CommentWrapper, { children: [(0, jsx_runtime_1.jsxs)(exports.Comment, { children: ["\u201E", item.comment, "\u201C"] }), (0, jsx_runtime_1.jsxs)(exports.Author, { children: [(0, jsx_runtime_1.jsx)("strong", { children: item.name }), ", ", item.role, (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("a", { href: item.url, target: "_blank", rel: "noreferrer", children: item.company })] })] })] }, item.name));
            }) }));
};
exports.Testimonials = Testimonials;
